import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Machine from "./pages/MasalaMachine/Machine";
import CustomMachine from "./pages/CustomMachine";

const App = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/*">
            <Route index element={<Home />} />
            <Route path="machine" element={<Machine />} />
            <Route path="custom-machine" element={<CustomMachine />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default App;
